module.exports = __webpack_public_path__ + "img/kanghong.9efb9cff.png";